import { rem } from 'polished';
import InputSlots, { normalizeValues } from '../slots/InputSlots/InputSlots';
import Box from './Box/Box';
import Button from './Button/Button';
import Stack from './Stack/Stack';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { submitForm } from '../services/externalForm';
import { track } from '../utils/analytics';

export const DownloadForm = ({ data }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const { file_to_be_downloaded, form_title, form } = data;
    const { submit_url, cta_text, success_msg, fields, cta_tracking_event } =
        form.document.data;
    const { handleSubmit, register, errors, control, reset, setError } =
        useForm();

    const onSubmit = (values) => {
        setIsSubmitting(true);

        const normalizedValues = normalizeValues(values);
        submitForm({ url: submit_url, data: normalizedValues })
            .then((res) => {
                setIsSubmitted(true);
                window.open(file_to_be_downloaded.url);
                track(cta_tracking_event);
                reset();
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <Stack
            as="form"
            onSubmit={handleSubmit(onSubmit)}
            space={rem(20)}
            noValidate
            backgroundColor="neutral.white"
            borderRadius="sm"
            p={rem(32)}
            boxShadow="primary-thin"
        >
            <InputSlots
                inputs={fields}
                excludePersonalEmailDomains
                wrapFirstTwoFields
                extendProps={({ key, is_required, pattern, label }) => ({
                    ref: register({
                        required: is_required,
                        pattern,
                    }),
                    error: errors[key],
                    control,
                    label,
                })}
            />
            <Box py={rem(8)}>
                <Button
                    size="lg"
                    fullWidth
                    loading={isSubmitting}
                    disabled={isSubmitted}
                >
                    {isSubmitted ? success_msg : cta_text}
                </Button>
            </Box>
        </Stack>
    );
};
